var _style, _path, _ellipse, _path2, _ellipse2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEasterBunnyEars = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  id: "easter-bunny-ears_svg__Layer_1",
  x: 0,
  y: 0,
  viewBox: "0 0 432 432"
}, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".easter-bunny-ears_svg__st0{fill:#ee7eb2}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M100.11 386.02c-2.23 0-4.43-1.05-5.82-3.01-1.16-1.64-28.68-40.87-46.57-101.63-10.51-35.73-15.44-71.47-14.66-106.24.99-43.55 11-85.64 29.75-125.1a7.12 7.12 0 0 1 4.12-3.68c1.81-.62 3.8-.49 5.51.37 1.32.66 32.54 16.69 61.47 64.66 16.77 27.82 29.38 60.79 37.46 97.99 10.04 46.21 13.1 99.15 9.09 157.37a7.123 7.123 0 0 1-7.6 6.62c-3.93-.27-6.9-3.67-6.62-7.6 8.78-127.69-19.03-204.24-43.91-245.98-19.31-32.4-39.88-49.36-49.97-56.36-36.59 82.65-26.35 161.62-10.96 213.93 17.22 58.5 44.25 97.02 44.52 97.41 2.28 3.21 1.52 7.66-1.69 9.94-1.26.88-2.7 1.31-4.12 1.31"
})), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  cx: 106.59,
  cy: 233.1,
  className: "easter-bunny-ears_svg__st0",
  rx: 31.77,
  ry: 119.02,
  transform: "rotate(-11.008 106.618 233.112)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M331.89 386.02c2.23 0 4.43-1.05 5.82-3.01 1.16-1.64 28.68-40.87 46.57-101.63 10.51-35.73 15.44-71.47 14.66-106.24-.99-43.55-11-85.64-29.75-125.1a7.12 7.12 0 0 0-4.12-3.68c-1.81-.62-3.8-.49-5.51.37-1.32.66-32.54 16.69-61.46 64.66-16.77 27.82-29.38 60.79-37.46 97.99-10.04 46.21-13.1 99.15-9.09 157.37a7.123 7.123 0 0 0 7.6 6.62c3.93-.27 6.9-3.67 6.62-7.6-8.78-127.69 19.03-204.24 43.91-245.98 19.31-32.4 39.88-49.36 49.97-56.36 36.59 82.64 26.36 161.61 10.96 213.92-17.22 58.5-44.25 97.02-44.52 97.41-2.28 3.21-1.52 7.66 1.69 9.94 1.25.89 2.69 1.32 4.11 1.32"
})), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 325.41,
  cy: 233.1,
  className: "easter-bunny-ears_svg__st0",
  rx: 119.02,
  ry: 31.77,
  transform: "rotate(-78.989 325.4 233.094)"
})));
export default SvgEasterBunnyEars;